<div class="modal-content">
<h3 fxLayoutAlign="center">Incluir CNPJ</h3>

<form [formGroup]="formGroup">
    <div fxLayout="column" fxLayoutAlign="center">
        <ng-container>
            <div fxLayoutGap="20px" fxLayoutAlign="center" class="filter-container">
                <div fxFlex="30">
                    <fd-input [parentForm]="formGroup" [field]="fields.cnpj">
                    </fd-input>
                </div>
                <div fxFlex="60">
                    <fd-input [parentForm]="formGroup" [field]="fields.name">
                    </fd-input>
                </div>
            </div>
        </ng-container>        
    </div>

    <div mat-dialog-actions align="center" >
      <div class="value-edit-table__button-container">
        <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"></fd-button>
        <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="save()">
        </fd-button>
      </div>
    </div>
</form>